<template>
    <div class="nav-content-wrapper" v-if="!$store.state.waitingRequest">
        <admin-navbar />
        
        <div class="content">
            <h2>Ajouter un jeu</h2>

            <form action="" method="POST" @submit.prevent="validation">
                <p v-if="erreurTitre">{{ erreurTitre }}</p>
                <input type="text" placeholder="Titre" :value="titre" @input="titre= $event.target.value" @focus="erreursTitre" @keyup="erreursTitre" :class="{ border: erreurTitre }" />
                
                <p v-if="erreurTitreUrl">{{ erreurTitreUrl }}</p>
                <input type="text" placeholder="Titre URL" :value="titre_url" @input="titre_url= $event.target.value" @focus="erreursTitreUrl" @keyup="erreursTitreUrl" :class="{ border: erreurTitreUrl }" />
                
                <p v-if="erreurDescription">{{ erreurDescription }}</p>
                <textarea placeholder="Description" :value="description" @input="description= $event.target.value" @focus="erreursDescription" @keyup="erreursDescription" :class="{ border: erreurDescription }"></textarea>
                
                <p v-if="erreurUrlIframe">{{ erreurUrlIframe }}</p>
                <input type="text" placeholder="URL Iframe" :value="iframe_url" @input="iframe_url= $event.target.value" @focus="erreursUrlIframe" @keyup="erreursUrlIframe" :class="{ border: erreurUrlIframe }" />

                <p v-if="erreurMiniature">{{ erreurMiniature }}</p>
                <label>Miniature</label>
                <input type="file" @change="changeEventMiniature" :class="{ border: erreurMiniature }" :key="fileInputKey" />
                <p>Le format de l'image doit être, de préférence, de 270 x 196</p>
                
                <label>Catégorie</label>
                <select v-model="idCategorie">
                    <option v-for="cat in lesCategories" :key="cat.id" :value="cat.id">{{ cat.libelle }}</option>
                </select>
                
                <p v-if="erreurTags">{{ erreurTags }}</p>
                <input type="text" placeholder="Tags" :value="tags" @input="tags= $event.target.value" @focus="erreursTags" @keyup="erreursTags" :class="{ border: erreurTags }" />

                <label>Visibilité du jeu</label>
                <select v-model="isGamePrivate">
                    <option value="0">Public</option>
                    <option value="1">Privé</option>
                </select>

                <input type="submit" value="Ajouter" />

                <p v-if="alerte">{{ alerte }}</p>
            </form>

            <br /><br /><br />

            <h2>Liste des jeux existants</h2>

            <label>Rechercher un jeu </label>
            <input type="text" :value="search" @input="search= $event.target.value" @keyup="searchAllGames" />
            
            <!-- <div class="search-results"> -->
            <div>
                <li v-for="game in foundGames" :key="game.title">
                    <img :src="'/games/static/miniatures/'+game.image_url" width="80" />
                    <!-- <div class="img"><div class="background" :style="{'background-image' : 'url(\'/games/static/miniatures/'+game.image_url+'\')'}"></div></div> -->
                    <div class="right">
                        <p>{{ game.title }}</p>
                    </div>
                </li>
                
                <li class="no-results" v-if="search.trim().length > 0 && foundGames.length <= 0">Aucun résultat</li>
            </div>
        </div>
    </div>
</template>

<script>
import Session from '../mixins/adminSession';
import AdminNavbar from '../views/AdminNavbar';

export default {
    name: 'AdminAddGame',
    mixins: [Session],
    components: {
        'admin-navbar': AdminNavbar
    },
    data() {
        return {
            titre: '',
            titre_url: '',
            description: '',
            iframe_url: '',
            miniature: '',
            lesCategories: [],
            idCategorie: '1',
            tags: '',
            isGamePrivate: '0',

            bannedUrlTitles: [],
            fileInputKey: 0,

            erreurTitre: '',
            erreurTitreUrl: '',
            erreurDescription: '',
            erreurUrlIframe: '',
            erreurMiniature: '',
            erreurTags: '',

            alerte: '',

            foundGames: [],
            search: '',
        }
    },
    mounted() {
        this.bannedUrlTitles = ['categories', 'categorie', 'favoris', 'recherche', 'register', 'login', 'me'];
        this.getCategories();
    },
    methods: {
        getCategories() {
            let formData = new FormData();
            formData.append('data', JSON.stringify({post: "1"}));
            
            axios
            .post(
            this.$store.state.apiUrl+"?request=getCategories", formData
            )
            .then((response) => {
                if(response.data.length > 0) {
                    this.lesCategories = response.data;
                }
            });
        },
        changeEventMiniature(e) {
            this.miniature = e.target.files[0];
            this.erreursMiniature();
        },
        titreValide() {
            let valide = false;

            if (this.titre && this.titre.trim() && this.titre.length <= 100) {
                valide = true;
            }
            return valide;
        },
        titreUrlValide() {
            let valide = false;
            let regex = /^[A-Za-z0-9-]+$/;

            if (this.titre_url && this.titre_url.trim() && regex.test(this.titre_url) && this.titre_url.length <= 100 && this.titre_url && !this.bannedUrlTitles.includes(this.titre_url)) {
                valide = true;
            }
            return valide;
        },
        descriptionValide() {
            let valide = false;

            if (this.description && this.description.trim() && this.description.length <= 1000) {
                valide = true;
            }
            return valide;
        },
        urlIframeValide() {
            let valide = false;
            let regex = /^(https?):\/\/[^\s]*$/;

            if (this.iframe_url && this.iframe_url.trim() && regex.test(this.iframe_url) && this.iframe_url.length <= 2000) {
                valide = true;
            }
            return valide;
        },
        miniatureValide() {
            let valide = false;

            if (this.miniature) {
                valide = true;
            }
            return valide;
        },
        tagsValides() {
            let valide = false;
            
            if (this.tags && this.tags.trim() && this.tags.length <= 150) {
                valide = true;
            }
            return valide;
        },
        erreursTitre() {
            this.erreurTitre = '';

            if (!this.titreValide()) {
                if (!this.titre || !this.titre.trim()) {
                    this.erreurTitre = 'Le titre est requis.';
                } else {
                    if (this.titre.length > 100) {
                        this.erreurTitre = 'Le titre ne doit pas dépasser 100 caractères.';
                    }
                }
            }
        },
        erreursTitreUrl() {
            this.erreurTitreUrl = '';

            if (!this.titreUrlValide()) {
                if (!this.titre_url || !this.titre_url.trim()) {
                    this.erreurTitreUrl = 'Le titre URL est requis.';
                } else {
                    let regex = /^[A-Za-z0-9-]+$/;
                    if (!regex.test(this.titre_url)) {
                        this.erreurTitreUrl = "Le titre URL n'est pas valide";
                    }
                    if(this.titre_url.length > 100) {
                        this.erreurTitreUrl = 'Le titre URL ne doit pas dépasser 100 caractères.';
                    }
                    if(this.bannedUrlTitles.includes(this.titre_url)) {
                        this.erreurTitreUrl = 'Le titre URL doit être différent.';
                    }
                }
            }
        },
        erreursDescription() {
            this.erreurDescription = '';

            if (!this.descriptionValide()) {
                if (!this.description || !this.description.trim()) {
                    this.erreurDescription = 'La description est requise.';
                } else {
                    if (this.description.length > 1000) {
                        this.erreurDescription = "La description ne doit pas dépasser 1000 caractères.";
                    }
                }
            }
        },
        erreursUrlIframe() {
            this.erreurUrlIframe = '';

            if (!this.urlIframeValide()) {
                if (!this.iframe_url || !this.iframe_url.trim()) {
                    this.erreurUrlIframe = "L'URL de l'Iframe est requise.";
                } else {
                    let regex = /^(https?):\/\/[^\s]*$/;
                    if (!regex.test(this.iframe_url)) {
                        this.erreurUrlIframe = "L'URL de l'Iframe n'est pas une URL valide.";
                    }
                    if (this.iframe_url.length > 2000) {
                        this.erreurUrlIframe = "L'URL de l'Iframe ne doit pas dépasser 2000 caractères.";
                    }
                }
            }
        },
        erreursMiniature() {
            this.erreurMiniature = '';
            
            if (!this.miniatureValide()) {
                if (!this.miniature) {
                    this.erreurMiniature = "Une miniature doit être sélectionnée.";
                }
            }
        },
        erreursTags() {
            this.erreurTags = '';

            if (!this.tagsValides()) {
                if (!this.tags || !this.tags.trim()) {
                    this.erreurTags = "Au moins un tag est requis.";
                } else {
                    if (this.tags.length > 150) {
                        this.erreurTags = "Les tags ne doivent pas dépasser 150 caractères.";
                    }
                }
            }
        },
        validation() {
            if (this.titreValide() && this.titreUrlValide() && this.descriptionValide() && this.urlIframeValide() && this.miniatureValide() && this.tagsValides()) {
                this.addGame();
            } else {
                this.erreursTitre();
                this.erreursTitreUrl();
                this.erreursDescription();
                this.erreursUrlIframe();
                this.erreursMiniature();
                this.erreursTags();
            }
        },
        addGame() {
            let data = JSON.stringify({
                post: '1',
                title: this.titre,
                title_url: this.titre_url,
                description: this.description,
                iframe_url: this.iframe_url,
                idCategorie: this.idCategorie,
                tags: this.tags,
                isGamePrivate: this.isGamePrivate,
            }); 
            let formData = new FormData();
            formData.append('file', this.miniature);
            formData.append('data', data);
            
            axios
            .post(
            this.$store.state.apiUrl+"?request=addGame", formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then((response) => {
                if(response.data == true) {
                    this.alerte = 'Le jeu a bien été ajouté';
                    
                    this.titre = '';
                    this.titre_url = '';
                    this.description = '';
                    this.iframe_url = '';
                    this.miniature = '';
                    this.fileInputKey++;
                    this.tags = '';
                    this.isGamePrivate = '0';
                }
                else if(response.data == 'titleExists') {
                    this.alerte = 'Le jeu ne peut pas être ajouté car le titre URL existe déjà';
                }
                else {
                    this.alerte = "Le jeu n'a pas été ajouté";
                }
            })
            .catch((error) => this.alerte = "Le jeu n'a pas pu être ajouté");
        },
        searchAllGames() {
            if(this.search.trim().length > 0) {
                let formData = new FormData();
                formData.append('data', JSON.stringify({post: "1", search: this.search}));
                
                axios
                .post(this.$store.state.apiUrl+"?request=searchAllGames", formData)
                .then((response) => {
                    if(response.data.length > 0) {
                        this.foundGames = response.data;
                    }
                    else {
                        this.foundGames = [];
                    }
                });
            }
            else {
                this.foundGames = [];
            }
        }
    },
    watch: {
        titre() {
            let newTitle = this.titre.normalize('NFD').replace(/[\u0300-\u036f]/g, "").replace(/[^a-zA-Z0-9]/g,'-').toLowerCase();
            this.titre_url = newTitle;
        }
    }
}
</script>

<style scoped src="@/assets/admin.css">
</style>
